<template>
    <div class="reservation">
        <loader v-if="!hasLoaded"></loader>

        <template v-else>
            <div class="hidden-print">
                <div class="page-header">
                    <h1>
                        Create reservation
                    </h1>
                </div>


                <div class="row">
                    <div class="col-lg-6 col-lg-offset-2 col-md-8 col-md-offset-1 col-sm-12">
                        <form class="form-horizontal">
                            <div class="form-group">
                                <label class="col-sm-4 control-label">Room</label>
                                <div class="col-sm-8">
                                    <multiselect placeholder="Room" v-model="selectedRoom" track-by="label" label="label" :options="roomOptions" :close-on-select="true" :show-labels="false"></multiselect>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-4 control-label">Type</label>
                                <div class="col-sm-8">
                                    <multiselect placeholder="Type" v-model="selectedType" track-by="label" label="label" :options="typeOptions" :close-on-select="true" :show-labels="false"></multiselect>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-4 control-label">Name</label>
                                <div class="col-sm-8">
                                    <input type="text" class="form-control" v-model="reservation.name">
                                </div>
                            </div>

                            <div class="form-group" :class="{'has-error': doubleBooking}">
                                <label class="col-sm-4 control-label">Arrival</label>
                                <div class="col-sm-8">
                                    <date-picker v-model="arrival" :config="{format: 'YYYY-MM-DD'}"></date-picker>
                                </div>
                            </div>

                            <div class="form-group" :class="{'has-error': doubleBooking}">
                                <label class="col-sm-4 control-label">Departure</label>
                                <div class="col-sm-8">
                                    <date-picker v-model="departure" :config="{format: 'YYYY-MM-DD'}"></date-picker>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-4 control-label">Price</label>
                                <div class="col-sm-4">
                                    <small>Per night</small>
                                    <input type="text" class="form-control" v-model="reservation.pricePerNight" @keyup="updatePriceTotal">
                                </div>
                                <div class="col-sm-4">
                                    <small>Total</small>
                                    <input type="text" class="form-control" v-model="reservation.price" @keyup="updatePriceNight">
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-4 control-label">Number of guests</label>
                                <div class="col-sm-8">
                                    <input type="text" class="form-control" v-model="reservation.guests">
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-4 control-label">Breakfast</label>
                                <div class="col-sm-4">
                                    <small>Eating guests</small>
                                    <input type="text" class="form-control" v-model="reservation.numberOfBreakfasts">
                                </div>
                                <div class="col-sm-4">
                                    <small>Total for all nights</small>
                                    <input type="text" class="form-control" v-model="reservation.totalPriceBreakfast">
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-4 control-label">Comment</label>
                                <div class="col-sm-8">
                                    <textarea class="form-control" v-model="reservation.comment"></textarea>
                                </div>
                            </div>

                            <br />

                            <div class="form-group">
                                <div class="col-sm-offset-4 col-sm-8">
                                    <button type="button" class="btn btn-primary" @click="create">Create reservation</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import Loader from '@/components/layout/Loader'
    import Multiselect from 'vue-multiselect'

    import DatePicker from 'vue-bootstrap-datetimepicker'

    const RoomService = require('@/services/rooms/RoomService')
    const ReservationService = require('@/services/reservations/ReservationService')
    const TypeService = require('@/services/reservations/TypeService')

    const moment = require('moment')

    export default {
        data() {
            return {
                hasLoaded: false,
                doubleBooking: false,

                rooms: [],
                selectedRoom: null,

                types: [],
                selectedType: null,

                arrival: moment(),
                departure: moment(),

                reservation: {
                    name: null,
                    comment: null,
                    pricePerNight: 0,
                    price: 0,
                    room: null,
                    guests: 0
                }
            }
        },

        watch: {
            selectedRoom() {
                this.$set(this.reservation, 'room', this.selectedRoom.value)

                const rooms = this.rooms.filter((room) => {
                    return room.id === this.selectedRoom.value
                })

                if (rooms.length) {
                    this.$set(this.reservation, 'guests', rooms[0].type.guests)
                }
            },

            selectedType() {
                this.$set(this.reservation, 'type', this.selectedType.value)
            },

            arrival() {
                this.updatePriceTotal()
            },

            departure() {
                this.updatePriceTotal()
            }
        },

        computed: {
            roomOptions() {
                return this.rooms.map((room) => {
                    return {
                        label: room.title,
                        value: room.id
                    }
                })
            },

            typeOptions() {
                return this.types.map((type) => {
                    return {
                        label: type.title,
                        value: type.id
                    }
                })
            },

            nights() {
                const nights = moment(this.departure).diff(moment(this.arrival), 'days')

                if (isNaN(nights)) {
                    return 1
                }

                return nights + 1
            }
        },

        mounted() {
            this.loadRooms()
        },

        methods: {
            loadRooms() {
                const options = {
                    includes: ['type'],

                    sort: [{
                        key: 'title',
                        direction: 'ASC'
                    }]
                }

                RoomService.findAll(options, (response) => {
                    const data = response.data

                    this.rooms = data.rows

                    TypeService.findAll({}, (response) => {
                        this.types = response.data.rows
                        this.hasLoaded = true
                    })
                })
            },

            create() {
                this.doubleBooking = false

                const reservation = this.reservation


                if (!reservation.name || !reservation.type || !reservation.room || !reservation.price || !this.arrival || !this.departure) {
                    return
                }

                reservation.arrival = this.arrival.format('YYYY-MM-DD')
                reservation.departure = this.departure.format('YYYY-MM-DD')

                ReservationService.create(reservation, (response) => {
                    const data = response.data

                    this.$router.push({
                        name: 'reservations.view',
                        params: {
                            id: data.id
                        }
                    })
                }, (response) => {
                    this.doubleBooking = true
                })
            },

            updatePriceNight() {
                this.$set(this.reservation, 'pricePerNight', this.reservation.price / this.nights)
            },

            updatePriceTotal() {
                this.$set(this.reservation, 'price', this.reservation.pricePerNight * this.nights)
            }
        },

        components: {
            Loader,
            DatePicker,
            Multiselect
        }
    }
</script>


// WEBPACK FOOTER //
// Create.vue?63f5c33c